module.exports = __webpack_public_path__ + "assets/img/dailyTask-top-tit.78996a01.png";